import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import { PDPAction, PDPSwarovskiProductFrontend } from "../state/types";
import { RenderVariantPicker } from "./RenderVariantPicker";
import { VariantPickerVariation, VariantPickerVariationCol } from "./utils";

export const PDPPicker: ReactTFC<{
  headline: string;
  attributes: Array<VariantPickerVariation>;
  disabled: boolean;
  selectedProduct: PDPSwarovskiProductFrontend;
  languageName: string;
  onPDPActionClick: (pdpAction: PDPAction) => void;
}> = props => {
  function getAttributes(): VariantPickerVariationCol {
    const tag = props.attributes[0]!.tag;
    // TODO: Make it typesafe!

    //@ts-expect-error
    return {
      tag: tag,
      values: props.attributes,
    };
  }

  return (
    <RenderVariantPicker
      attributes={getAttributes()}
      selectedProduct={props.selectedProduct}
      languageName={props.languageName}
      onPDPActionClick={props.onPDPActionClick}
      disabled={props.disabled}
      headline={props.headline}
    />
  );
};
